'use strict';

const Cookies = require('js-cookie');

let customerNo = Cookies.get('bo_customer_number');
let membership = Cookies.get('_bo_memberships');

let rewards = Cookies.get('bo_scorecard_rewards');
let capacity = Cookies.get('bo_scorecard_capacity');
let propensity = Cookies.get('bo_scorecard_propensity');
let recency = Cookies.get('bo_scorecard_recency');
let frequency = Cookies.get('bo_scorecard_frequency');
let price = Cookies.get('bo_scorecard_price');
let new_work = Cookies.get('bo_scorecard_new');
let engagement = Cookies.get('bo_scorecard_engagement');

/*
 - capacity_to_give
 - engagement_level
 - frequency_of_visits
 - member_of_rewards_program
 - new_work_amenability
 - number_of_rewards_points
 - price_sensitivity
 - propensity_to_give
 - recency_visits
*/

module.exports = {
    init: function() {
        window.dataLayer = window.dataLayer || [];
        
        if (customerNo) {
            window.dataLayer.push({
                'userId': customerNo
            });
        }

        if (rewards) {
            window.dataLayer.push({
                'tessitura_rewards': rewards
            })
        }
        if (capacity) {
            window.dataLayer.push({
                'tessitura_capacity': capacity
            })
        }
        if (propensity) {
            window.dataLayer.push({
                'tessitura_propensity': propensity
            })
        }
        if (recency) {
            window.dataLayer.push({
                'tessitura_recency': recency
            })
        }
        if (frequency) {
            window.dataLayer.push({
                'tessitura_frequency': frequency
            })
        }
        if (price) {
            window.dataLayer.push({
                'tessitura_price': price
            })
        }
        if (new_work) {
            window.dataLayer.push({
                'tessitura_new_work': new_work
            })
        }
        if (engagement) {
            window.dataLayer.push({
                'tessitura_engagement': engagement
            })
        }

        if (membership) {
            window.dataLayer.push({
                'tessitura_engagement_level': membership
            });
        }
    }
}



// WEBPACK FOOTER //
// ./modules/tracking.js